import React from 'react';

export const Doc = props => (
  <svg
    width="36"
    height="38"
    viewBox="0 0 36 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_dd_2613_7933)">
      <rect
        x="1.59961"
        y="0.800049"
        width="32"
        height="32"
        rx="8"
        fill="url(#paint0_linear_2613_7933)"
      />
      <rect
        x="1.99961"
        y="1.20005"
        width="31.2"
        height="31.2"
        rx="7.6"
        stroke="white"
        strokeWidth="0.8"
      />
      <path
        d="M5.75879 16.4004H29.4395C29.894 16.4004 30.2113 16.4007 30.458 16.4209C30.6998 16.4407 30.8391 16.4776 30.9443 16.5312C31.1699 16.6463 31.3538 16.83 31.4688 17.0557C31.5223 17.1609 31.5594 17.3003 31.5791 17.542C31.5992 17.7886 31.5996 18.1054 31.5996 18.5596V20.96C31.5996 22.7587 31.5992 24.0837 31.5137 25.1309C31.4285 26.1733 31.2606 26.9057 30.9453 27.5244C30.3701 28.6532 29.4521 29.5713 28.3232 30.1465C27.7045 30.4617 26.9721 30.6287 25.9297 30.7139C24.8826 30.7994 23.5573 30.7998 21.7588 30.7998H13.4395C11.6408 30.7998 10.3157 30.7994 9.26855 30.7139C8.22608 30.6287 7.49373 30.4617 6.875 30.1465C5.74614 29.5713 4.82817 28.6532 4.25293 27.5244C3.93767 26.9057 3.77072 26.1733 3.68555 25.1309C3.59999 24.0837 3.59961 22.7587 3.59961 20.96V18.5596C3.59961 18.1053 3.59999 17.7886 3.62012 17.542C3.63988 17.3001 3.67684 17.161 3.73047 17.0557C3.84552 16.8299 4.02909 16.6463 4.25488 16.5312C4.3602 16.4776 4.49928 16.4407 4.74121 16.4209C4.98783 16.4008 5.30454 16.4004 5.75879 16.4004Z"
        fill="url(#paint1_linear_2613_7933)"
        stroke="#2B589C"
        strokeWidth="0.8"
      />
      <path
        d="M3.19922 12.64C3.19922 13.536 3.19922 13.9841 3.37361 14.3263C3.52701 14.6274 3.77177 14.8722 4.07283 15.0256C4.41509 15.2 4.86313 15.2 5.75922 15.2H29.4392C30.3353 15.2 30.7833 15.2 31.1256 15.0256C31.4267 14.8722 31.6714 14.6274 31.8248 14.3263C31.9992 13.9841 31.9992 13.536 31.9992 12.64C31.9992 9.05562 31.9992 7.26345 31.3017 5.89441C30.6881 4.69017 29.709 3.7111 28.5048 3.09751C27.1357 2.39995 25.3436 2.39995 21.7592 2.39995H13.4392C9.85488 2.39995 8.06272 2.39995 6.69368 3.09751C5.48944 3.7111 4.51037 4.69017 3.89678 5.89441C3.19922 7.26345 3.19922 9.05562 3.19922 12.64Z"
        fill="url(#paint2_linear_2613_7933)"
      />
      <g filter="url(#filter1_di_2613_7933)">
        <path
          d="M10.9268 27H8.56117V20.6H10.9237C11.5758 20.6 12.1372 20.7281 12.608 20.9844C13.081 21.2385 13.4455 21.6052 13.7018 22.0844C13.958 22.5615 14.0862 23.1323 14.0862 23.7969C14.0862 24.4635 13.958 25.0365 13.7018 25.5156C13.4476 25.9948 13.0841 26.3625 12.6112 26.6187C12.1383 26.8729 11.5768 27 10.9268 27ZM10.108 25.6812H10.8674C11.2258 25.6812 11.5289 25.6208 11.7768 25.5C12.0268 25.3771 12.2153 25.1781 12.3424 24.9031C12.4716 24.626 12.5362 24.2573 12.5362 23.7969C12.5362 23.3365 12.4716 22.9698 12.3424 22.6969C12.2133 22.4219 12.0226 22.224 11.7705 22.1031C11.5205 21.9802 11.2122 21.9187 10.8455 21.9187H10.108V25.6812ZM20.9199 23.8C20.9199 24.5042 20.7845 25.101 20.5137 25.5906C20.2428 26.0802 19.8762 26.4521 19.4137 26.7062C18.9533 26.9604 18.4366 27.0875 17.8637 27.0875C17.2887 27.0875 16.771 26.9594 16.3105 26.7031C15.8501 26.4469 15.4845 26.075 15.2137 25.5875C14.9449 25.0979 14.8105 24.5021 14.8105 23.8C14.8105 23.0958 14.9449 22.499 15.2137 22.0094C15.4845 21.5198 15.8501 21.1479 16.3105 20.8937C16.771 20.6396 17.2887 20.5125 17.8637 20.5125C18.4366 20.5125 18.9533 20.6396 19.4137 20.8937C19.8762 21.1479 20.2428 21.5198 20.5137 22.0094C20.7845 22.499 20.9199 23.0958 20.9199 23.8ZM19.3387 23.8C19.3387 23.3833 19.2793 23.0312 19.1605 22.7437C19.0439 22.4562 18.8751 22.2385 18.6543 22.0906C18.4355 21.9427 18.172 21.8687 17.8637 21.8687C17.5574 21.8687 17.2939 21.9427 17.073 22.0906C16.8522 22.2385 16.6824 22.4562 16.5637 22.7437C16.447 23.0312 16.3887 23.3833 16.3887 23.8C16.3887 24.2167 16.447 24.5687 16.5637 24.8562C16.6824 25.1437 16.8522 25.3615 17.073 25.5094C17.2939 25.6573 17.5574 25.7312 17.8637 25.7312C18.172 25.7312 18.4355 25.6573 18.6543 25.5094C18.8751 25.3615 19.0439 25.1437 19.1605 24.8562C19.2793 24.5687 19.3387 24.2167 19.3387 23.8ZM27.5224 22.9187H25.9599C25.9391 22.7583 25.8964 22.6135 25.8318 22.4844C25.7672 22.3552 25.6818 22.2448 25.5755 22.1531C25.4693 22.0615 25.3433 21.9917 25.1974 21.9437C25.0537 21.8937 24.8943 21.8687 24.7193 21.8687C24.4089 21.8687 24.1412 21.9448 23.9162 22.0969C23.6933 22.249 23.5214 22.4687 23.4005 22.7562C23.2818 23.0437 23.2224 23.3917 23.2224 23.8C23.2224 24.225 23.2828 24.5812 23.4037 24.8687C23.5266 25.1542 23.6985 25.3698 23.9193 25.5156C24.1422 25.6594 24.4058 25.7312 24.7099 25.7312C24.8808 25.7312 25.036 25.7094 25.1755 25.6656C25.3172 25.6219 25.4412 25.5583 25.5474 25.475C25.6558 25.3896 25.7443 25.2865 25.813 25.1656C25.8839 25.0427 25.9328 24.9042 25.9599 24.75L27.5224 24.7594C27.4953 25.0427 27.413 25.3219 27.2755 25.5969C27.1401 25.8719 26.9537 26.1229 26.7162 26.35C26.4787 26.575 26.1891 26.7542 25.8474 26.8875C25.5078 27.0208 25.1183 27.0875 24.6787 27.0875C24.0995 27.0875 23.5808 26.9604 23.1224 26.7062C22.6662 26.45 22.3058 26.0771 22.0412 25.5875C21.7766 25.0979 21.6443 24.5021 21.6443 23.8C21.6443 23.0958 21.7787 22.499 22.0474 22.0094C22.3162 21.5198 22.6797 21.1479 23.138 20.8937C23.5964 20.6396 24.1099 20.5125 24.6787 20.5125C25.0662 20.5125 25.4245 20.5667 25.7537 20.675C26.0828 20.7812 26.3724 20.9375 26.6224 21.1437C26.8724 21.3479 27.0755 21.599 27.2318 21.8969C27.388 22.1948 27.4849 22.5354 27.5224 22.9187Z"
          fill="url(#paint3_linear_2613_7933)"
          shapeRendering="crispEdges"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dd_2613_7933"
        x="-0.000390768"
        y="4.88162e-05"
        width="35.2"
        height="37.6"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="0.8"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_2613_7933"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.905882 0 0 0 0 0.905882 0 0 0 0 0.905882 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2613_7933"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="3.2"
          operator="erode"
          in="SourceAlpha"
          result="effect2_dropShadow_2613_7933"
        />
        <feOffset dy="3.2" />
        <feGaussianBlur stdDeviation="2.4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_2613_7933"
          result="effect2_dropShadow_2613_7933"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_2613_7933"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_di_2613_7933"
        x="8.56152"
        y="19.7125"
        width="18.9609"
        height="8.17495"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.8" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.168627 0 0 0 0 0.345098 0 0 0 0 0.611765 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2613_7933"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2613_7933"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.8" />
        <feGaussianBlur stdDeviation="0.8" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2613_7933"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2613_7933"
        x1="17.5996"
        y1="0.800049"
        x2="17.5996"
        y2="32.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F1F1F1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2613_7933"
        x1="17.5992"
        y1="16"
        x2="17.5992"
        y2="31.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2B589C" />
        <stop offset="1" stopColor="#4571B5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2613_7933"
        x1="17.5992"
        y1="2.39995"
        x2="17.5992"
        y2="15.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F4F4F4" />
        <stop offset="1" stopColor="#F4F4F4" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2613_7933"
        x1="18"
        y1="19.4667"
        x2="18"
        y2="25.7"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
    </defs>
  </svg>
);
